export  default {
    /*获取分类*/
    appType:'/pms/pms/sysresource/getAllColumnResource',
    appList:'/pms/pms/sysresource/getMenuResourceByPidAndCommunityId',
    subscribe:'/pms/pms/sysresource/subscriptionSysResource',
    cancelSubscribe:'/pms/pms/sysresource/unsubscribeSysResource',
}
